__turbopack_context__.v({
  "popup": "InfoPopup-module-scss-module__5KMooW__popup",
  "popup_body": "InfoPopup-module-scss-module__5KMooW__popup_body",
  "popup_box": "InfoPopup-module-scss-module__5KMooW__popup_box",
  "popup_close": "InfoPopup-module-scss-module__5KMooW__popup_close",
  "popup_close_icon": "InfoPopup-module-scss-module__5KMooW__popup_close_icon",
  "popup_content": "InfoPopup-module-scss-module__5KMooW__popup_content",
  "popup_footer": "InfoPopup-module-scss-module__5KMooW__popup_footer",
  "popup_footer_btn": "InfoPopup-module-scss-module__5KMooW__popup_footer_btn",
  "popup_footer_inner": "InfoPopup-module-scss-module__5KMooW__popup_footer_inner",
  "popup_footer_text": "InfoPopup-module-scss-module__5KMooW__popup_footer_text",
  "popup_header": "InfoPopup-module-scss-module__5KMooW__popup_header",
  "popup_note": "InfoPopup-module-scss-module__5KMooW__popup_note",
  "popup_overlay": "InfoPopup-module-scss-module__5KMooW__popup_overlay",
  "popup_title": "InfoPopup-module-scss-module__5KMooW__popup_title",
});
